// extracted by mini-css-extract-plugin
export default {"input":"Input_input__iPCqr","muted":"Input_muted__CXYj6"};